import type { CommandProperties } from '@atlassian/rovo-content-bridge-api/command';

import { CommandHandler } from './command-handler';

export class SendContextReadyCommandHandler extends CommandHandler<CommandProperties, void> {
	execute(): void {
		this.props.onSendContextReady?.();
	}
}
